export const greenMui = {
  /**
   * Preview: ![green 50](https://mui.com/static/colors-preview/green-50-24x24.png)
   */
  _50: "#e8f5e9",
  /**
   * Preview: ![green 100](https://mui.com/static/colors-preview/green-100-24x24.png)
   */
  _100: "#c8e6c9",
  /**
   * Preview: ![green 200](https://mui.com/static/colors-preview/green-200-24x24.png)
   */
  _200: "#a5d6a7",
  /**
   * Preview: ![green 300](https://mui.com/static/colors-preview/green-300-24x24.png)
   */
  _300: "#81c784",
  /**
   * Preview: ![green 400](https://mui.com/static/colors-preview/green-400-24x24.png)
   */
  _400: "#66bb6a",
  /**
   * Preview: ![green 500](https://mui.com/static/colors-preview/green-500-24x24.png)
   */
  _500: "#4caf50",
  /**
   * Preview: ![green 600](https://mui.com/static/colors-preview/green-600-24x24.png)
   */
  _600: "#43a047",
  /**
   * Preview: ![green 700](https://mui.com/static/colors-preview/green-700-24x24.png)
   */
  _700: "#388e3c",
  /**
   * Preview: ![green 800](https://mui.com/static/colors-preview/green-800-24x24.png)
   */
  _800: "#2e7d32",
  /**
   * Preview: ![green 900](https://mui.com/static/colors-preview/green-900-24x24.png)
   */
  _900: "#1b5e20",
  /**
   * Preview: ![green A100](https://mui.com/static/colors-preview/green-A100-24x24.png)
   */
  A100: "#b9f6ca",
  /**
   * Preview: ![green A200](https://mui.com/static/colors-preview/green-A200-24x24.png)
   */
  A200: "#69f0ae",
  /**
   * Preview: ![green A400](https://mui.com/static/colors-preview/green-A400-24x24.png)
   */
  A400: "#00e676",
  /**
   * Preview: ![green A700](https://mui.com/static/colors-preview/green-A700-24x24.png)
   */
  A700: "#00c853",
};
